import { User } from "@supabase/supabase-js";
import { create } from "zustand";
import supabase from "../utils/supabase";
import { resolveStateName } from "../config/courseTypes";

interface UserState {
  user: User | undefined;
  profile: any | null;
  stateName: string;
  authResolved: boolean;
  setUser: (user: User | undefined) => void;
  fetchUserProfile: (userArg: User) => Promise<void>;
  setProfile: (profile: any | null) => void;
  setAuthResolved: (resolved: boolean) => void;
}

const useUserStore = create<UserState>()((set, get) => ({
  user: undefined,
  profile: null,
  stateName: "Oklahoma",
  authResolved: false,
  setUser: (user: User | undefined) => set({ user }),
  setProfile: (profile: any | null) => set({ profile }),
  setAuthResolved: (authResolved: boolean) => set({ authResolved }),
  fetchUserProfile: async (userArg?: User) => {
    const user = userArg || get().user;
    if (!user) {
      console.warn("No user provided. Cannot fetch profile.");
      set({ profile: null });
      return;
    }

    try {
      const { data, error } = await supabase
        .from("profiles")
        .select("*")
        .eq("id", user.id)
        .maybeSingle();

      if (error) throw error;

      if (!data.district) {
        set({ profile: data });
        return;
      }

      const { data: districtData, error: districtError } = await supabase
        .from("districts")
        .select("*")
        .eq("id", data.district)
        .maybeSingle();
      if (districtError) throw districtError;
      if (districtData?.state != null) {
        const { data: stateData, error: stateError } = await supabase
          .from("state")
          .select("*")
          .eq("id", districtData.state)
          .maybeSingle();
        if (!stateError && stateData?.name) {
          set({ stateName: resolveStateName(stateData.name, districtData.course_type) });
        }
      }
      set({ profile: data });
    } catch (error) {
      console.error("Error fetching user profile:", error);
      set({ profile: null });
    }
  },
}));

export default useUserStore;
